import { render, staticRenderFns } from "./HighlightedLocations.vue?vue&type=template&id=71760484&scoped=true"
import script from "./HighlightedLocations.vue?vue&type=script&lang=ts"
export * from "./HighlightedLocations.vue?vue&type=script&lang=ts"
import style0 from "./HighlightedLocations.vue?vue&type=style&index=0&id=71760484&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71760484",
  null
  
)

export default component.exports